$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('input-text')) {
    customElements.define(
      'input-text',
      class inputText extends HTMLElement {
        constructor() {
          super();
        }
        requiredText = '';
        formatText = '';
        rule = '';
        connectedCallback() {
          this.init();
          const $container = $(this.querySelector('.input_text_container'));
          this.requiredText = $container.data('tipEmpty');
          this.formatText = $container.data('tipFormat');
          var ruleType = $container.data('rule');
          switch (ruleType) {
            case 'email':
              this.rule = ltUtils.rule.email;
              break;
            case 'password':
              this.rule = ltUtils.rule.password; // 密码规则: 至少包含一个字母和一个数字
              break;
            case 'password_confirmation':
              this.rule = ltUtils.rule.password_confirmation;
              break;
            // 其他规则可以继续添加
            default:
              this.rule = null; // 默认情况，如果没有匹配规则，可以设置为 null 或空正则
          }
        }

        init() {
          const _this = this;
          const $placeholder_text = $(this.querySelector('.placeholder_text'));
          this.addEventListener('click', function () {
            $placeholder_text.css('top', '0.5rem').css('transform', 'translateY(0)');
            _this.focusInput();
            this.querySelector('.input_text_container').setAttribute('data-focus', 'true');
          });
          const $input = $(this.querySelector('input'));
          $input.on('change', function () {
            $placeholder_text.css('top', '0.5rem').css('transform', 'translateY(0)');
          });

          // 获取input的value
          const value = $input.val();
          if (value) {
            $placeholder_text.css('top', '0.5rem').css('transform', 'translateY(0)');
          }
          $input.blur(this.blurInput.bind(this));
        }

        focusInput() {
          const input = this.querySelector('input');

          if (input) {
            input.focus();
          }
        }

        blurInput() {
          this.querySelector('.input_text_container').setAttribute('data-focus', 'false');
          const $input = $(this.querySelector('input'));
          const value = $input.val();
          // 判断元素是否为必填
          const required = $input.attr('required');
          // 获取父元素为 input_text_container
          const $inputContainer = $input.parents('.input_text_container');
          // 获取与$inputContainer同级的 error-message元素
          const $errorMessage = $inputContainer.siblings('.error-message');
          if (!value) {
            const $placeholder_text = $(this.querySelector('.placeholder_text'));
            $placeholder_text.css('top', '50%').css('transform', 'translateY(-50%)');
            if (required) {
              $inputContainer.attr('data-error', 'true');
              $errorMessage.text(this.requiredText);
            }
          } else {
            if (this.rule) {
              if (this.rule.test(value)) {
                $inputContainer.attr('data-error', 'false');
              } else {
                $inputContainer.attr('data-error', 'true');
                $errorMessage.text(this.formatText);
              }
            } else {
              $inputContainer.attr('data-error', 'false');
            }
          }

          if (window.location.pathname.includes('/account/reset')) {
            let reset_customer = $('.reset_customer')[0];
            const passwordInput = reset_customer.querySelector('input[name="customer[password]"]');
            const passwordConfirmInput = reset_customer.querySelector('input[name="customer[password_confirmation]"]');
            const inputContainer = passwordConfirmInput.closest('.input_text_container'); // 获取最近的父容器
            if (passwordConfirmInput.value && passwordInput.value !== passwordConfirmInput.value) {
              if (passwordConfirmInput) {
                let siblingErrorMessage = Array.from(inputContainer.parentNode.children).find(
                  (child) => child !== inputContainer && child.classList.contains('error-message')
                );

                siblingErrorMessage.textContent = window.i18n.password_confirmation_different;
                inputContainer.setAttribute('data-error', 'true');
                return false;
              }
            } else if (passwordInput.value == passwordConfirmInput.value) {
              inputContainer.setAttribute('data-error', 'false');
            }
          }
        }
      }
    );
  }
});
